import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '@app/@core/local-storage/local-storage.service';
import { AlertService } from '@app/@core/services/alert.service';
import { AppService } from '@app/@core/services/app.service';
import { HttpService } from '@app/@core/services/http.service';
import { LoaderService } from '@app/@core/services/loader.service';
import { LocalService } from '@app/@core/services/local.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import moment from 'moment';
import { YouthPhotoService } from '../@core/youth-photo.service';

declare const $: any;
declare const Image: any;

const deletePhotoSelector = '#deletephoto';
const imageListUrl = '../../image-list';
@Component({
  standalone: false,
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss']
})
export class DocumentUploadComponent implements OnInit {
  documentUploadForm: UntypedFormGroup;
  alertService: AlertService;
  @ViewChild('file')
  fileInput: ElementRef;
  imageHeight: number;
  imageWidth: number;
  isButtonShowHide: boolean = false;
  photoTypeList: any;
  fileName: any = '';
  fileSize: any = 0;
  isImageUploaded: boolean = false;
  imgUrl: any;
  imgUrl2: any;
  photoId: any;
  youthPhotoDetails: any;
  settingInfo: any;
  showDescription: boolean = false;
  sourceKey: string;
  sourceValue: string;
  youthId: string;
  descriptionList: any[] = [];
  defaultDescriptionList: any[];
  fileNamePath: string;
  workerId: any;
  loaderService: LoaderService;
  maxDate: any;
  previousType: any;
  isEditMode: boolean = false;
  fileSizeRaw: number;
  errorMessage = 'Something went wrong.';
  pageId: any;
  hidePrimaryFlag = false;
  storageService: LocalStorageService;
  localStoreService: LocalService;
  youthPhotoService: YouthPhotoService;
  httpService: HttpService;
  appService: AppService;

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private permissionStore: PermissionStore,
    private router: Router) {
    this.alertService = injector.get<AlertService>(AlertService);
    this.loaderService = injector.get<LoaderService>(LoaderService);
    this.storageService = injector.get<LocalStorageService>(LocalStorageService);
    this.localStoreService = injector.get<LocalService>(LocalService);
    this.youthPhotoService = injector.get<YouthPhotoService>(YouthPhotoService);
    this.httpService = injector.get<HttpService>(HttpService);
    this.appService = injector.get<AppService>(AppService);
    this.photoTypeList = [
      { value: 'YTH', label: 'Youth' },
      { value: 'SCR', label: 'Scar, Mark or Tattoo' }
    ];
    this.defaultDescriptionList = [
      { value: 'Intake/Commitment', label: 'Intake/Commitment' },
      { value: 'Annual', label: 'Annual' },
      { value: 'Appearance Change', label: 'Appearance Change' },
      { value: 'Exit/Release', label: 'Exit/Release' },
      { value: 'Other', label: 'Other' }
    ];
    this.photoId = this.route.snapshot.paramMap.get('photoid');
    this.sourceKey = this.route.parent.parent.snapshot.paramMap.get('sourceKey');
    this.sourceValue = this.route.parent.parent.snapshot.paramMap.get('sourceValue');
    if (this.sourceKey && this.sourceKey.includes('youth_id')) {
      this.youthId = this.sourceValue;
    }
    this.maxDate = new Date();
    this.localStoreService.setItem('gridAction', 'add');
    this.route.parent?.params.subscribe(params => {
      this.pageId = params['pageId'];
      console.log('Page ID:', this.pageId);
    });
  }

  ngOnInit(): void {
    this.youthPhotoService.getActivePage(this.pageId, true, 'add').subscribe(res => {
      if (res && 'data' in res) {
        const pageResponse = res as { data: { pagePermission: any; assetPermissions: any } };
        const pageAccess = pageResponse.data.pagePermission;
        const assetAccess = pageResponse.data.assetPermissions;

        this.permissionStore.state['pageAccess'] = pageAccess;
        this.permissionStore.state['assetAccess'] = assetAccess;
      } else {
        console.error('Unexpected response format:', res);
      }
    });
    this.initializeDocumentUploadForm();
    const REGISTRATION = this.storageService.getItem('REGISTRATION');
    if (REGISTRATION) {
      this.settingInfo = JSON.parse(REGISTRATION);
    }
    if (this.photoId) {
      this.getByPhotoId();
      this.isButtonShowHide = true;
    }
  }

  initializeDocumentUploadForm() {
    const currentDate = new Date();
    const username = JSON.parse(this.localStoreService.getItem('user'));
    const userId = this.localStoreService.getItem('id')
    this.documentUploadForm = this.formBuilder.group({
      youth_id: [Number(this.youthId)],
      entered_date: [{ value: currentDate, disabled: true }, Validators.required],
      type_code: ['', Validators.required],
      photo_date: [currentDate, Validators.required],
      primary_flag: [false],
      entered_by_worker_name: [{ value: `${username.lastname}, ${username.firstname}${username.middlename ? ' ' + username.middlename : ''}`, disabled: true }],
      entered_by_worker_id: [`${userId}`],
      description: ['', Validators.required],
      moreDescription: ['', [Validators.required, Validators.maxLength(100)]],
      url_pic: ['', Validators.required]
    });
  }

  uploadFile(fileValue: any) {
    const file = fileValue[0];

    this.validateDocument(file).then(isValid => {
      if (isValid) {
        const imageData = {
          contentType: fileValue[0].type,
          fileName: this.fileNamePath
        };
        this.youthPhotoService.uploadKey(imageData).subscribe((res: any) => {
          this.httpService.putUpload(res.data, file, file.type).subscribe((_resp: any) => {
            this.imgUrl2 = res.data;
            this.documentUploadForm.patchValue({ url_pic: this.fileName });
            this.isImageUploaded = true;
          })
        },
      (_error) => {
        this.alertService.error(this.errorMessage)
      })
      }
    });
  }

  validateDocument(file: any): Promise<boolean> {
    return new Promise((resolve, _reject) => {
      const fileSize = Number(file.size) / 1024;
      const filetype = file.type.split('/')[1];
      const fileNameLength = file.name.length;
      const reader = new FileReader();
      this.loaderService.show();
      reader.onload = (e: any) => {
        this.loaderService.hide();
        if (filetype !== 'jpg' && filetype !== 'jpeg' && filetype !== 'png' && filetype !== 'jfif') {
          this.fileInput.nativeElement.value = "";
            this.alertService.error(`JPG, JPEG, PNG & JFIF are supported.`);
            this.clearImage();
            resolve(false);
            return;
        } else if (fileNameLength > 100) {
          this.alertService.warn('The filename is too long.');
          resolve(false);
          return;
        }
        const img = new Image();
        img.src = e.target.result;

        img.onload = () => {
          this.imageWidth = img.width;
          this.imageHeight = img.height;
              if (fileSize <= 3072) {
                this.fileName = file.name;
                this.fileSizeRaw = parseFloat(fileSize.toFixed(1));
                this.fileSize = this.getFileSize(parseFloat(fileSize.toFixed(1)));
                this.fileNamePath = `youth-photo/${this.youthId}/${moment().valueOf()}-${this.fileName.replaceAll(' ', '')}`;
                resolve(true);
              } else {
                this.fileInput.nativeElement.value = "";
                this.alertService.warn('File size exceeds 3MB limit.');
                resolve(false);
              }
        };
      };

      reader.readAsDataURL(file);
    });
  }

  sendDocument() {
    if (this.documentUploadForm.valid) {
      const formData = this.documentUploadForm.getRawValue();
      if (formData.primary_flag) {
        formData['primary_flag'] = 'Y'
      } else {
        formData['primary_flag'] = 'N'
      }
      formData['youth_photo_id'] = Number(this.photoId);
      formData['url_pic'] = this.fileNamePath;
      if (this.showDescription) {
        formData['description'] = formData.moreDescription
      }
      formData['photo_date'] = moment(formData['photo_date']).format("YYYY-MM-DD");
      formData['entered_date'] = moment(formData['entered_date']).format("YYYY-MM-DD");
      if (this.photoId) {
        this.youthPhotoService.updateYouthPhoto(formData).subscribe((_res: any) => {
          this.alertService.success('Youth Photo updated successfully.', true);
          this.resetData();
          this.router.navigate([imageListUrl], { relativeTo: this.route });
        },
        (_error) => {
          this.alertService.error(this.errorMessage)
        })
      } else {
        this.youthPhotoService.addPhoto(formData).subscribe((res: any) => {
          formData['primary_flag'] === 'Y' && this.appService.setValue('youth_pic', res?.data?.url_pic);
          this.alertService.success('Youth Photo added successfully.', true);
          this.resetData();
          this.router.navigate(['../image-list'], { relativeTo: this.route });
        },
        (_error) => {
          this.alertService.error(this.errorMessage)
        });
      }
    }
  }

  openModal() {
    $(deletePhotoSelector).modal('show');
  }

  resetValue() {
    if (this.photoId) {
      this.isEditMode = true;
      this.fileName = this.youthPhotoDetails['file_name'].split('/')[1];
      this.documentUploadForm.patchValue(this.youthPhotoDetails);
      if (this.documentUploadForm.get('type_code').value === 'YTH') {
        this.descriptionList = [];
        this.descriptionList = this.defaultDescriptionList;
        this.showDescription = false;
        this.documentUploadForm.get('primary_flag')?.enable();
        this.imgUrl2 = this.documentUploadForm.get('url_pic').value;
        this.isImageUploaded = true;
        this.documentUploadForm.patchValue({ description: this.youthPhotoDetails['description'] });
      } else {
        this.showDescription = true;
        this.documentUploadForm.get('primary_flag')?.disable();
        this.documentUploadForm.patchValue({
          moreDescription: this.documentUploadForm.get('description').value,
          description: 'Other',
        });
      }
    } else {
      this.router.navigate(['../image-list'], { relativeTo: this.route });
    }
  }

  clearImage() {
    this.documentUploadForm.patchValue({ url_pic: '' });
    this.fileName = '';
    this.fileSize = 0;
    this.fileSizeRaw = 0;
    this.isImageUploaded = false;
    this.isEditMode = false;
    this.imgUrl2 = '';
  }

  getByPhotoId() {
    this.youthPhotoService.getByPhotoId(this.photoId).subscribe((res: any) => {
      console.log('getByPhotoId', res);
      if (res && res.data && res.data.length) {
        this.isEditMode = true;
        const youthPhotoDetails = res.data[0];
        youthPhotoDetails['entered_date'] = moment().format('MM/DD/YYYY');
        youthPhotoDetails['photo_date'] = moment().format('MM/DD/YYYY');
        if (youthPhotoDetails.primary_flag === 'Y') {
          youthPhotoDetails['primary_flag'] = true;
        } else if (youthPhotoDetails.primary_flag === 'N') {
          youthPhotoDetails['primary_flag'] = false;
        }
        youthPhotoDetails['youth_id'] = Number(this.youthId);
        youthPhotoDetails['entered_by_worker_id'] = Number(youthPhotoDetails.entered_by_worker_id);
        this.documentUploadForm.patchValue(youthPhotoDetails);
        this.previousType = youthPhotoDetails['type_code'];
        this.youthPhotoDetails = youthPhotoDetails;
        if (youthPhotoDetails.type_code === 'YTH') {
          this.documentUploadForm.get('primary_flag')?.enable();
          this.documentUploadForm.controls.moreDescription.clearValidators();
          this.documentUploadForm.controls.moreDescription.updateValueAndValidity();
        } else {
          this.getPhysicalDescriptionList();
          this.documentUploadForm.get('primary_flag')?.disable();
        }
        this.isImageUploaded = true;
        this.imgUrl2 = youthPhotoDetails.url_pic;
        this.fileName = youthPhotoDetails.file_name.split('/')[1]
        const url = youthPhotoDetails.url_pic.split('?')[0].split('/')
        this.fileNamePath = `${url[4]}/${url[5]}`;
      }

    },
    (_error) => {
      this.alertService.error(this.errorMessage)
    })
  }

  getDateFormat(value: any) {
    if (this.settingInfo) {
      if (value === 'date') {
        return this.settingInfo['datetimeformat'].split(' ')[0];
      }
      return this.settingInfo['datetimeformat'];
    }
    return 'MM/dd/yyyy';
  }

  resetData() {
    this.documentUploadForm.reset();
    this.fileSize = 0;
    this.fileSizeRaw = 0;
    this.fileName = '';
    this.isImageUploaded = false;
    this.fileNamePath = '';
  }

  changeTypeValue(e) {
    if(e.value === null){
      this.hidePrimaryFlag = false;
      this.documentUploadForm.get('primary_flag')?.setValue(false);
      this.documentUploadForm.get('primary_flag')?.enable();
    } else if (e.value !== 'YTH') {
      this.getPhysicalDescriptionList();
      this.documentUploadForm.patchValue({primary_flag: false});
      this.documentUploadForm.get('primary_flag')?.disable();
      this.hidePrimaryFlag = true;
      this.documentUploadForm.get('description').reset();
      this.documentUploadForm.get('moreDescription').reset();
      this.showDescription = false;
    } else {
      this.descriptionList = this.defaultDescriptionList;
      this.documentUploadForm.get('description').reset();
      this.documentUploadForm.get('moreDescription').reset();
      this.documentUploadForm.get('primary_flag')?.enable();
      this.documentUploadForm.get('primary_flag')?.setValue(true);
      this.youthPhotoService.getYouthPhoto(this.youthId).subscribe((res: any) => {
        const getPrimaryYouth = res.data.filter((item) => item.primary_flag === 'Y');
        if (getPrimaryYouth?.length === 0) {
          // Disable the primary_flag form control
          this.documentUploadForm.get('primary_flag')?.disable();
        }
      });
      this.hidePrimaryFlag = false;
      this.showDescription = false;
    }
  }

  deletePhoto() {
    this.youthPhotoService.deleteYouthPhoto(this.photoId).subscribe((res: any) => {
      if (res?.data?.warn) {
        this.alertService.warn(res.data.warn);
        this.photoId = '';
        $(deletePhotoSelector).modal('hide');
        this.resetData();
        this.router.navigate([imageListUrl], { relativeTo: this.route });
      }
      else if (res?.data?.message){
        this.alertService.success(res.data.message);
        this.photoId = '';
        $(deletePhotoSelector).modal('hide');
        this.resetData();
        this.router.navigate([imageListUrl], { relativeTo: this.route });
      }
    },
    (_error) => {
      this.alertService.error(this.errorMessage)
    })
  }

  changeDescriptionValue(e) {
    if (e.value === 'Other') {
      this.showDescription = true;
      this.documentUploadForm.controls.moreDescription.setValidators([
        Validators.required,
        Validators.maxLength(100)
      ]);
      this.documentUploadForm.controls.moreDescription.updateValueAndValidity();
    } else {
      this.showDescription = false;
      this.documentUploadForm.controls.moreDescription.clearValidators();
      this.documentUploadForm.controls.moreDescription.updateValueAndValidity();
    }
  }

  getPhysicalDescriptionList() {
    this.youthPhotoService.getPhysicalDescription(this.youthId).subscribe((res: any) => {
      if (res && res.data) {
        this.descriptionList = [];
        res.data.forEach(pd => {
          this.descriptionList.push({
            value: [
              pd.type_description,
              pd.body_part_description,
              pd.body_side_description,
              pd.design
          ].filter(Boolean).join('; '),
            label: [
                pd.type_description,
                pd.body_part_description,
                pd.body_side_description,
                pd.design
            ].filter(Boolean).join('; ')
        });
       });
        this.descriptionList.push({ value: 'Other', label: 'Other' });
        this.validateDescription();
      }
    },
    (_error) => {
      this.alertService.error(this.errorMessage)
    })
  }

  validateDescription() {
    const isPresent = this.descriptionList.some(item => item.label === this.documentUploadForm.get('description').value);
    if (!isPresent && this.photoId && this.previousType !== 'YTH') {
      this.showDescription = true;
      this.documentUploadForm.patchValue({
        moreDescription: this.documentUploadForm.get('description').value,
        description: 'Other',
      })
    }
  }

  getFileSize(fileSize){
    if (fileSize > 1024) {
      fileSize = fileSize / 1024;
      return `${fileSize.toFixed(2)} MB`
    } else {
      return `${fileSize.toFixed(2)} KB`
    }
  }

  get moreDescription() {
    return this.documentUploadForm.get('moreDescription');
  }
}
